'use client'
import { SbBlokData, storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc'
import { FC, useEffect, useState } from 'react'

import { linkUrl } from '@/lib/link'
import { stylePanelSBData } from '@/lib/stylePanel'

import { PhnxFeaturecards } from './Featurecards'
import { FeaturecardsProps } from './Featurecards'

interface FeaturecardsBlokProps {
  blok: {
    title: FeaturecardsProps['title']
    layout: any
    description: SbBlokData[]
    items: SbBlokData[]
    button: SbBlokData[]
    padding?: SbBlokData[]
    background?: SbBlokData[]
    colour?: SbBlokData[]
    alignment?: SbBlokData[]
  } & SbBlokData
}

const Featurecards: FC<FeaturecardsBlokProps> = ({ blok }) => {
  const [cards, setCards] = useState<any[]>([])
  let stylePanel = stylePanelSBData(blok.colour, blok.background, blok.alignment, blok.padding)

  useEffect(() => {
    if (blok.items && blok.items.length > 0) {
      const cards = blok.items.map((item: any) => {
        const title = item.title
        const asset = { src: item.asset?.filename, alt: item.asset?.alt }
        const link = linkUrl(item.link)
        return { title, asset, content: item.content, link, linkLabel: item.linkLabel }
      })

      setCards(cards)
    }
  }, [blok.items])

  return (
    <div {...storyblokEditable(blok)}>
      <PhnxFeaturecards
        title={blok.title}
        description={
          blok.description &&
          blok.description.map((nestedBlok: SbBlokData) => (
            <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))
        }
        layout={blok.layout}
        items={cards}
        textColor={stylePanel.textColor}
        backgroundColor={stylePanel.backgroundColor}
        padding={stylePanel.padding}
        alignment={stylePanel.alignment as 'left' | 'center' | 'right'}
        button={
          blok.button &&
          blok.button.map((nestedBlok: SbBlokData) => (
            <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))
        }
      />
    </div>
  )
}

export default Featurecards
